// extracted by mini-css-extract-plugin
export default {"root":"RefinementQuestionsModal_root__Tj3KF","modalContainer":"RefinementQuestionsModal_modalContainer__i+MSh"};